export const PENDING_UPLOAD_DEEP_SEARCH_KEY = 'webelieve_pending_upload_deep_search';

export type UploadedDocumentHandoffProvider = 'edgecite_weaviate';

export interface PendingUploadDeepSearchHandoff {
  provider?: UploadedDocumentHandoffProvider;
  matterId: string;
  documentId: string;
  versionId: string;
  documentTitle: string;
  jobId?: string | null;
  chunkCount?: number | null;
  citationCount?: number | null;
  clauseCount?: number | null;
  partyCount?: number | null;
  prompt: string;
  createdAt: string;
}

export function buildDefaultUploadedDocumentPrompt(documentTitle: string): string {
  const safeTitle = documentTitle.trim() || 'the uploaded document';
  return `Using the EdgeCite/Weaviate analysis for "${safeTitle}", summarize the document and focus on key obligations, deadlines, citations, clauses, parties, risks, and next actions.`;
}
